/**
 * 描述：弹出框高度修正指令
 * 日期：2017-10-25
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module('modalDialogHeightFixModule', [])
    . directive('modalDialog', ['$timeout', function($timeout) {
        return {
            restrict: 'C',
            replace: false,
            link: function(scope, $elem, $attrs) {
                init();
                dragAndDrop();

                /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
                function init() {
                    $timeout(function() {
                        var htmlHight = $('body')[0].offsetHeight;
                        var modalHeight = $elem[0].offsetHeight;
                        if ($elem.find('.publicModal .body').eq(0)) {
                            var bodyHeight = $elem.find('.publicModal .body')[0].offsetHeight;
                            var moreThan = (modalHeight + 60) - htmlHight;
                            if (moreThan > 0) {
                                if ((bodyHeight - moreThan) > 50) {
                                    $elem.find('.publicModal .body').eq(0).height(bodyHeight - moreThan);
                                    $elem.height(modalHeight - moreThan);
                                    setRoll();
                                } else {
                                    var newModalBody = bodyHeight - 50 > 0 ? 50 : bodyHeight;
                                    $elem.find('.publicModal .body').eq(0).height(newModalBody);
                                    $elem.height(modalHeight - (bodyHeight - newModalBody));
                                    setRoll();
                                }
                            } else {
                                if ($('.publicModal .body').eq(0).css('overflow-y') == 'auto') {
                                    if ($elem.find('.publicModal .bdoc').length == 1) {
                                        setopacity();
                                    }
                                }
                            }
                            var oft = (htmlHight - $elem.height()) / 2;
                            oft = oft > 0 ? oft : 0;
                            $elem.animate({
                                top: oft,
                                opacity: 1
                            }, 100);
                        } else {
                            init();
                        }
                    }, 500);
                    var setRoll = function() {
                        $elem.find('.publicModal .body').eq(0).css({ 'overflow-y': 'auto', 'overflow-x': 'hidden' });
                        if ($elem.find('.publicModal .bdoc').length == 1) {
                            // setopacity();
                        }
                    };

                    function setopacity() {
                        var maskTop = document.createElement('div');
                        var footer = $elem.find('.publicModal .footer').eq(0);
                        var fW = footer.width();
                        maskTop.setAttribute('class', 'mask');
                        $timeout(function() {
                            footer.append(maskTop);
                            footer.find('.mask').css('width', fW + 60 + 'px');
                            if ($elem.find('.publicModal .body').eq(0).height() >= $elem.find('.publicModal .bdoc').height()) {
                                footer.find('.mask').css('display', 'none');
                            }
                        }, 300);
                        $elem.find('.publicModal .body').scroll(function() {
                            var q = $elem.find('.publicModal .body').scrollTop();
                            var bodyH = $elem.find('.publicModal .body').height();
                            var innerH = $elem.find('.publicModal .bdoc').height();
                            // console.log("inner===" + Math.floor(innerH) + "======sroll===" + Math.floor(q) + "========bodyheight=" + bodyH);
                            if (Math.floor(innerH) <= Math.floor(q + bodyH + 60)) {
                                footer.find('.mask').css('display', 'none');
                            } else {
                                footer.find('.mask').css('display', 'block');
                            }
                        });
                    }
                }
                scope.$on('modalDialogBroadcast', function(event, data) {
                    $elem.find('.publicModal .body').eq(0).removeAttr('style');
                    $elem.find('.footer .mask').hide();
                    $elem.css('height', '');
                    init();
                });

                /**
             * [dragAndDrop description] 支持弹窗拖拽功能
             * @return {[type]} [description]
             */
                function dragAndDrop() {
                    $elem.find('.modal-content').eq(0).draggable({ containment: 'div.modal', handle: 'div.header' });
                }
            }
        };
    }]);
